import React from 'react'
import Image from 'next/image'
import { CarouselSlideProps } from '~types'
import { PortalModal } from '~elements'
import styles from './CarouselSlide.module.scss'
import { constructS3Url } from 'utils'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { useWindowSize } from 'utils/hooks'

const CarouselSlide = ({ img, title, description, showModal = false, handleImageClick }: CarouselSlideProps) => {
  const { imageAlt = '', imageUrlS3 } = img || {}
  const { isBreakpoint: isBelowBreakpointMd } = useWindowSize('md', '<')

  if (!imageUrlS3) return null

  const ImageComponent = props => {
    const { width, height } = props
    return imageUrlS3 ? (
      <Image
        src={constructS3Url(imageUrlS3)}
        alt={imageAlt}
        width={width}
        height={height}
        quality={NEXT_IMAGE_QUALITY}
      />
    ) : null
  }

  return (
    <div className={styles.slide}>
      <div className={styles['image-container']} onClick={handleImageClick}>
        <ImageComponent width={isBelowBreakpointMd ? 280 : 720} height={isBelowBreakpointMd ? 320 : 520} />
      </div>
      <p>{title}</p>
      {description && <p>{description}</p>}
      {showModal && (
        <PortalModal handleModalClose={handleImageClick} isOpen={showModal}>
          <ImageComponent width={isBelowBreakpointMd ? 280 : 720} height={isBelowBreakpointMd ? 320 : 520} />
        </PortalModal>
      )}
    </div>
  )
}

export default CarouselSlide
